module.exports = __webpack_public_path__ + "static/media/IIT_childrens1.47c90cac.png";